<template>
    <div class="tab-pane" :class="{'active' : user_type=='3'}" id="admission-detail-tab" aria-labelledby="admission-detail-tab">
        <div class="form-group row">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <label for="name" class="form-label">Dzongkhag: <span class="text-danger">*</span></label>
                <select v-model="dzongkhag_id" class="form-control" aria-label="dzongkhag_id" :class="{ 'is-invalid': is_invalid }" id="dzongkhag_id" @change="getOrganization();">
                    <option v-for="(item, i) in dzongkhags" :key="i" :value="item.id">{{item.name}}</option>
                </select>
                <span v-if="is_invalid">{{error}}</span>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <label for="name" class="form-label">Admission Type: <span class="text-danger">*</span></label>
                <select v-model="type" class="form-control" aria-label="status" @change="getAdmittedList()">
                    <option value="admitted">Admitted</option>
                    <option value="not_admitted">Not Admitted</option>
                </select>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <label for="name" class="form-label">School:</label>
                <select v-model="school_id" class="form-control" aria-label="school_id" :class="{ 'is-invalid': is_invalid }" id="school_id" @change="getAdmittedList(),remove_err('school_id')">
                    <option v-for="(item, i) in schools" :key="i" :value="item.id">{{item.organization}}</option>
                </select>
                <span v-if="is_invalid">{{error}}</span>
            </div>
        </div>
        <div v-show="showTable">
            <table id="admission" class="table table-bordered table-striped" style="width:100%" >
                <thead>
                    <tr>
                        <th colspan="5" class="text-center">Student Information</th>
                        <th colspan="6" class="text-center">Student Placement</th>
                    </tr>
                    <tr>
                        <th>S.No</th>
                        <th>Name of Student</th>
                        <th>Index Number</th>
                        <th>Dzongkhag</th>
                        <th>School</th>
                        <th>Dzongkhag</th>
                        <th>School</th>
                        <th>Class</th>
                        <th>Stream</th>
                        <th>Remarks</th>
                        <th>Action</th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in admission_details" :key="index">
                        <td>{{index + 1}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.std_indexno}}</td>
                        <td>{{item.dzongkhag}}</td>
                        <td>{{item.organization}}</td>
                        <td>{{item.placement_dzo}}</td>
                        <td>{{item.placement_org}}</td>
                        <td>{{item.class}}</td>
                        <td>{{item.stream}}</td>
                        <td>{{item.remarks}}</td>
                        <td>
                            <span v-if="item.remarks=='admitted'">
                                <div  class="btn btn-info btn-sm btn-flat text-white" @click="showedit(item)"><i class="fas fa-edit"></i > Edit</div>
                                <div  class="btn btn-info btn-sm btn-flat text-white m-2" @click="rejectAdmittedStudents(item.id)"> Delete</div>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            showTable:true,
            dzongkhags:[],
            dzongkhag_id:'',
            schools:[],
            school_id:'',
            user_type:'',
            type:'admitted',
            admission_details:[],
            is_invalid:false,
            error:'',
            dt:'',
        }
    },
    methods:{
        remove_err(fieldid){
            if($('#'+fieldid).val()!=""){
                $('#'+fieldid).removeClass('is-invalid');
                this.showTable=true;
            }else{
                this.is_invalid = true;
                this.error = "This field is required"
            }
        },
        getDzongkhags(){
          axios.get('dzongkhags/getDzongkhags')
            .then(response =>{ this.dzongkhags = response.data })
            .catch(error => console.log(error));
        },
        getOrganization(){
            this.schools = [];
            axios.get('school/getPublicOrganization/'+this.dzongkhag_id)
            .then(response =>{ this.schools = response.data })
            .catch(error => console.log(error));
        },
        getAdmittedList(){
            let uri = 'admissions/getAdmittedList/'+this.dzongkhag_id +'/'+this.type;
            if(this.school_id !=''){
                uri +='/'+this.school_id;
            }
            axios.get(uri).then(res =>{
                let data = res.data;
                this.admission_details = data
         
            }).catch(error => console.log(error));
        },
        showedit(data){
            this.$router.push({name:'class-xi-admission-edit',params: {data:data}});
        },
        rejectAdmittedStudents(detail_id){
            Swal.fire({
                 title: 'Do you want really want to delete?',
                 icon: 'warning',
                 showCancelButton: true,
                 confirmButtonColor: '#3085d6',
                 cancelButtonColor: '#d33',
                 confirmButtonText: 'Yes',
                 }).then((result) => {
                     if(result.isConfirmed) {
                         axios.post('admissions/deleteAdmittedStudent',{id:detail_id})
                             .then(() => {
                                 Toast.fire({
                                     icon: 'success',
                                     title: 'Date delete successfully '
                                 })
                                this.$router.go(this.$router.currentRoute)
                             })
                             .catch(function(error){
                                console.log(error);
                         });
                     }
             })
         }
    },
    mounted(){
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.user_type=data['role'];
            this.getDzongkhags()
        })
         this.dt = $("#admission").DataTable({ 
            dom: 'Bfrtip',
            buttons: [
                'csv', 'excel',
            ]
        });
    },
    watch: {
        admission_details(val) {
            this.dt.destroy();
            this.$nextTick(() => {
                this.dt = $("#admission").DataTable({
                    dom: 'Bfrtip',
                    buttons: [
                        'csv', 'excel',
                    ]
                })
            });
        }
    }
    
}
</script>